export const ASSETS = {
  logos: {
    title: {
      path: 'assets/title.png',
      width: 200,
      height: 80
    },
    playStore: {
      path: 'assets/play_store.png',
      width: 120,
      height: 50
    },
    appStore: {
      path: 'assets/app_store.svg',
      width: 120,
      height: 50
    }
  },
  backgrounds: {
    boxArt: {
      path: 'assets/backgrounds/box_art.png',
      width: 390,
      height: 844
    },
    background: {
      path: 'assets/backgrounds/background.png',
      width: 390,
      height: 844
    },
    start: {
      path: 'assets/backgrounds/start.png',
      width: 390,
      height: 844
    },
    home: {
      path: 'assets/backgrounds/home.png',
      width: 390,
      height: 844
    },
    progress: {
      path: 'assets/backgrounds/progress.png',
      width: 390,
      height: 844
    },
    ranking: {
      path: 'assets/backgrounds/ranking.png',
      width: 390,
      height: 844
    },
    lobby: {
      path: 'assets/backgrounds/lobby.png',
      width: 390,
      height: 844
    },
    game: {
      path: 'assets/backgrounds/typing_arena.png',
      width: 390,
      height: 844
    }
  },
  locations: {
    typingClass: {
      path: 'assets/locations/typing_class.png',
      width: 390,
      height: 844
    },
    typingOffice: {
      path: 'assets/locations/typing_office.png',
      width: 390,
      height: 844
    },
    typingArena: {
      path: 'assets/backgrounds/typing_arena.png',
      width: 390,
      height: 844
    }
  },
  resources: {
    energy: {
      path: 'assets/icons/energy.png',
      width: 512,
      height: 512
    },
    wordCoins: {
      path: 'assets/icons/word_coins.png',
      width: 512,
      height: 512
    },
    gamekey: {
      path: 'assets/icons/gamekey.png',
      width: 100,
      height: 100
    },
    letterGems: {
      path: 'assets/icons/letter_gems.png',
      width: 512,
      height: 512
    }
  }
};
